// import { useEffect} from 'react';
import { useApi } from "./api"
// import { EventDTO, EventImage, EventPromoter, EventTicketPackageDTO } from "../models"
import { useContextState } from '../context/Context';
// import EventDetails from "../components/events/eventDetails";
// import Cookies from 'js-cookie';



export const useEventApi = () => {
    const { $post, $get, $put, $patch, $delete } = useApi()

    const { eventsCTX,  accountCTX } = useContextState();
    const { allEventsState : { pendingEvent }, dispatchAllEventsState } = eventsCTX
    const { signedIn } = accountCTX


    const getEvent = async (eventId:string) => {
        const path = 'events/get_event_for_support/'

        var data = await $get(path, false, {event_id:eventId})
        // console.log('data: ', data)
        if (data && (data.res === 'success' || data.res === 'failed')){
            return data
        }
        return 
    }

    const getEvents = async (resultIndex?:number) => {
        var path = 'events/?page=' + (resultIndex? resultIndex?.toString():'1')
        var data = await $get(path, false)
        // console.log(data)
        if (data && data.length > 0){
            dispatchAllEventsState({ type: 'SET_EVENTS', payload: {events: data} })
        }
        return data
    }

    const getTickets = async (ticketId:string, eventId:string, username:string) => {
        const path = 'events/tickets/get_tickets_for_support/'
        var data = await $get(path, false, {ticketId:ticketId, eventId:eventId, username:username})
        // console.log('tickets: ', data)
        if (data && (data.res === 'success' || data.res === 'failed')){
            return data
        }
        console.log('No data found')
        return 
    }

    const sendTicketsToBuyerViaEmail = async (ticketId:string) => {
        const path = 'events/tickets/send_ticket_via_email/'
        var data = await $get(path, false, {ticketId:ticketId})
        console.log('tickets: ', data)
        if (data && (data.res === 'success' || data.res === 'failed')){
            return data
        }
        console.log('No data found')
        return 
    }

  

    const cancelTicket = async (credentials: {eventId: string, ticketId:string, password:string }) => {
        const path = 'events/tickets/' + credentials.ticketId + '/'
        const data = await $delete(path, credentials)
        if (!data) return
        if (data.res === 'success'){
            dispatchAllEventsState({ type: 'CANCEL_TICKET', payload: { eventId: credentials.eventId, ticket: {'id': credentials.ticketId, 'status':'cancelled'} }})
        }
        return data
    }

    const scanGuest = async (credentials: {eventId: string, ticketId:string }) => {
        const data = await $post('event/scanGuest/', credentials, true)
        console.log(data)
        if (data.res === 'success' || data.res === 'failed'){
            return data
        }
        return 
    }

    return { 
        getEvent,
        getEvents,
        getTickets,
        sendTicketsToBuyerViaEmail,
        cancelTicket,
        scanGuest,
    }
}
